import React, { useEffect, useState } from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, useDisclosure, Textarea } from "@nextui-org/react";
import { useTranslation } from 'react-i18next';
import { updateSelectedMessage, useAppDispatch } from "@circuitry-ai/doc-data";
import { checkType, CtyButton, CtyShowToast, SearchableDropdown, SpeechUtility } from "@circuitry-ai/doc-ui";
import { feedbackOptions } from "./chat-options";
import { useClipboard } from "@nextui-org/use-clipboard";
import { Icon } from "@iconify/react";

const Copy = ({ message }: any) => {
    const dispatch = useAppDispatch();
    const { copied, copy } = useClipboard();
    const handleCopy = (message: string) => {
        copy(message);
        dispatch(updateSelectedMessage(message));
    };

    return (
        <CtyButton
            tooltipContent={feedbackOptions.COPY}
            toolTipColor='warning'
            isIconOnly
            radius="full"
            size="sm"
            variant="light"
            onPress={() => handleCopy(message ?? '')}
        >
            {copied ? (
                <Icon
                    className="text-lg text-default-600"
                    icon="gravity-ui:check"
                />
            ) : (
                <Icon
                    icon="lets-icons:copy-light"
                    height={20}
                    width={20}
                />
            )}
        </CtyButton>
    );
};

const TranslateModal = ({ message, onDialogClose }: any) => {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [messageData, setMessageData] = useState<string>(message);
    const [messageTranslating, setMessageTranslating] = useState<boolean>(false);
    const [selectedKey, setSelectedKey] = useState<string>(SpeechUtility.getLanguage() ?? "en-US");

    useEffect(() => { onOpen(); }, []);

    const onWindowClose = () => {
        onClose();
        onDialogClose();
    };

    const handleSelectionChange = async (key: string) => {
        try {
            setMessageTranslating(true);
            const speechUtilityInstance = await SpeechUtility.getInstance(dispatch);
            const transFormedText = await speechUtilityInstance.translateText(message, key);
            setMessageData(transFormedText);
        } catch (error) {
            CtyShowToast(checkType.error, (error as Error)?.message ?? 'Something went wrong!');
        } finally {
            setMessageTranslating(false);
        }
    };

    return (
        <Modal id="translate-modal" backdrop={"blur"} isOpen={isOpen} onClose={onWindowClose} className="max-h-[80%] max-w-[80%]" isDismissable={false} isKeyboardDismissDisabled={true}>
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-row justify-between items-center gap-3">
                            <div>{t('Translate Text')}</div>
                            <div className="flex flex-row items-center gap-2 mr-3">
                                <SearchableDropdown
                                    selectedKey={selectedKey}
                                    className='max-h-[200px] overflow-y-auto'
                                    onSelectionChange={(key) => {
                                        setSelectedKey(key);
                                        handleSelectionChange(key)
                                    }}
                                    availableLanguages={SpeechUtility.translateLanguages}
                                />
                                <Copy message={messageData} />
                            </div>
                        </ModalHeader>
                        <ModalBody className="overflow-y-auto">
                            <Textarea
                                isReadOnly
                                id="translate-modal-textarea"
                                type="text"
                                size='lg'
                                variant="bordered"
                                labelPlacement="outside"
                                value={messageTranslating ? 'Translating...' : messageData}
                                className='w-[100%] p-0 font-bold mb-2 '
                                placeholder={t("Message")}
                            />
                        </ModalBody>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};


export default TranslateModal;